import Glide from '@glidejs/glide';
import { TweenMax, Expo } from 'gsap';
import Rellax from 'rellax';

const rellax = new Rellax('.rellax', {
  speed: 2,
  center: true
});

new Glide('.glide', {
  type: 'carousel',
  perView: 4,
  breakpoints: {
      567: {
        perView: 1,
        peek: {
          before: 50,
          after: 50
        }
      }
    }
  
}).mount();

const hamburger = document.querySelector('.hamburger');
const menu = document.querySelector('.nav-menu');
const menuLi = document.querySelectorAll('.nav-menu li')
let isActive = false;

hamburger.addEventListener('click',() => {
  if(!isActive){
    hamburger.classList.add('active');
    isActive = true;
    TweenMax.to(menu, .5, {
      right: '0%',
      opacity: 1,
      ease: Expo.easeInOut
    });
    TweenMax.staggerFrom(menuLi, .65, {
      delay: .1,
      x: 100,
      opacity: 0,
      ease: Expo.easeInOut
    }, .15)
  } else {
    hamburger.classList.remove('active');
    isActive = false;
    TweenMax.to(menu, .3, {
      right: '-100%',
      opacity: 0,
      rotate: 10,
      ease: Expo.easeInOut
    });
  }
});

$("#feed-form").submit(() => {
  const form = jQuery('#feed-form');
  jQuery.ajax({
    type: "POST"
    , url: "/post.php"
    , data: form.serialize()
    , success: (data) => {
      $(form).html(data);
    }
    , error: (jqXHR, text, error) => {
      $(form).html(error);
    }
  });
  return false;
});

$(document).ready(function(){
  // Add smooth scrolling to all links
  $("a").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      const {hash} = this;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 500, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });
});